<template>
	<div id="sentiment_market_hot_day" :class="{ 'compact-mode': compact }">
		<!-- <b-button size="sm"  variant="outline-primary" @click="refresh()">刷新</b-button> -->
		<v-chart class="chart_hot_day" :options="line" @datazoom='onDataZoom($event,line)'/>
		<div class="text-right mb-1">
			<b-link v-b-toggle.hot-day-usage class="text-muted small">使用说明 <b-icon icon="info-circle" /></b-link>
		</div>
		<b-collapse id="hot-day-usage">
			<b-alert show variant="light" class="small py-2 mb-2">
				<ul class="mb-0">
					<li>按照天来量化情绪趋势，主要预判未来1天，其次3天</li>
					<li>趋势A：高位沸点后往下到达冰凉的趋势</li>
					<li>趋势B：低位冰点启动往上到达沸点的趋势</li>
					<li>重点在于尊重趋势，不要逆势操作，控制仓位，增加胜率</li>
					<li>新人注意：不要预判未来，指标出现反转才是反转，趋势的逆转不可预判</li>
				</ul>
			</b-alert>
		</b-collapse>
	</div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
	import Moment from 'moment'

	
	import {
		request_zzquant
	} from "network/request.js"

	const upColor = '#ec0000';
	const upBorderColor = '#8A0000';
	const downColor = '#00da3c';
	const downBorderColor = '#008F28';

	export default {
		props: {
			compact: {
				type: Boolean,
				default: false
			},
			title: {
				type: String,
				default: "按天情绪热度"
			},
			subText: {
				type: String,
				default: "热度周期"
			},
			zoom_start: {
				type: [Number, String],
				default: 70,
			},
			zoom_end: {
				type: Number,
				default: 100,
			}
		},
		mounted() {
			this.refresh();
			this.timer = setInterval(() => {  //创建定时器
				this.refresh_interval();
			}, 60000);
		},
		components: {
			'v-chart': ECharts
		},
		data() {
			return {
				auto_refresh: 0,
				timer: null, //首先我在data函数里面进行定义定时器名称
				line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: 0,
						textStyle: {
							color: '#94a3b8',
							fontSize: 14,
							fontWeight: 600
						},
						subtextStyle: {
							color: '#64748b',
							fontSize: 10
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						},
						formatter: function(params) {
							let res = params[0].name + '<br/>';
							params.forEach(item => {
								let val = item.value;
								if (item.seriesName === '跌停数') {
									val = Math.abs(val);
								}
								res += item.marker + item.seriesName + ': ' + val + '<br/>';
							});
							return res;
						}
					},axisPointer: {
						link: {xAxisIndex: 'all'},
						// label: {
						// 	backgroundColor: '#777'
						// }
					},
					toolbox: { //下载
						show: true,
						feature: {
							saveAsImage: {}
						}
					},
					legend: {
						top: 6,
						right: 45,
						data: ['按天情绪'],
						textStyle: {
							color: '#999999'
						},
					},
					visualMap: {
						// top: 10,
						// right: 10,
						type : 'piecewise',
						show: false,
						seriesIndex: 0,
						dimension:1,
						pieces: [
							{min: parseFloat(75), color: upBorderColor },
							{min: parseFloat(45), max: parseFloat(75), color: upColor},
							{min: parseFloat(35), max: parseFloat(45), color: downColor},
							{min: parseFloat(0), max: parseFloat(35), color: downBorderColor},
							],
						outOfRange: {
							symbol: 'rect', 
							symbolSize: [1,1],
							color:upBorderColor,
						}
					},
					grid: [{
							left: this.compact ? '5%' : '7%',
							right: this.compact ? '12%' : '8%',
							top: this.compact ? '12%' : '10%',
							height: '52%'
						},
						{
							left: this.compact ? '5%' : '7%',
							right: this.compact ? '12%' : '8%',
							top: '70%',
							height: '18%'
						}
					],
					xAxis: [{
							gridIndex: 0,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							splitLine: {
								show: false
							},
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisTick: {
								show: false
							},
							axisLabel: {
								show: false
							},
						},
						{
							gridIndex: 1,
							type: 'category',
							scale: true,
							axisLine: {
								onZero: false,
								lineStyle: {
									color: '#666666'
								}
							},
							splitLine: {
								show: false
							},
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10,
								color: '#999999',
								formatter: function(val) {
									if (val && val.length >= 10) {
										return val.substring(5);
									}
									return val;
								}
							},
						}
					],
					yAxis: [{
							gridIndex: 0,
							name: "热度",
							scale: true,
							position: 'right',
							min: 0,
							max: 100,
							splitNumber: 5,
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								formatter: '{value}',
								color: '#999999'
							},
							nameTextStyle: {
								color: '#999999'
							}
						}, 
						{
							gridIndex: 0,
							// name: "热度",
							min: 0,
							max: 100,
							scale: true,
							offset: 2,
							splitArea: {
								show: false
							},
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							splitLine: false,
							position: 'left',
						}, {
							gridIndex: 1,
							name: "涨跌停",
							scale: true,
							position: 'right',
							min: function(value) {
								let maxVal = Math.max(Math.abs(value.min || 0), Math.abs(value.max || 0));
								if (maxVal < 10) maxVal = 50;
								return -Math.ceil(maxVal / 50) * 50;
							},
							max: function(value) {
								let maxVal = Math.max(Math.abs(value.min || 0), Math.abs(value.max || 0));
								if (maxVal < 10) maxVal = 50;
								return Math.ceil(maxVal / 50) * 50;
							},
							splitNumber: 2,
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							axisTick:{
								show:true
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								formatter: function(value) {
									return Math.abs(value);
								},
								color: '#999999'
							},
							nameTextStyle: {
								color: '#999999'
							}
						},
						{
							gridIndex: 1,
							name: "连板高度",
							scale: true,
							position: 'left',
							min: 0,
							max: 12,
							splitNumber: 3,
							axisLine: {
								lineStyle: {
									color: '#666666',
									width: 1
								}
							},
							axisTick:{
								show:true
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								formatter: '{value}',
								color: '#999999'
							},
							nameTextStyle: {
								color: '#999999'
							}
						},
					],
					dataZoom: [
						// {
						// 	type: 'inside',
						// 	start: this.zoom_start,
						// 	end: this.zoom_end
						// },
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1],
							y: '90%',
							start: this.zoom_start,
							end: this.zoom_end,
							textStyle: {
								color: '#999999'
							}
						}
					],
					series: []
				}
			}
		},
		methods: {
			refresh_interval(){
				if(!this.auto_refresh) return;
				let  myDate = new Date();
				let day = myDate.getDay() //获取当前星期X(0-6,0代表星期天)
				let hour = myDate.getHours(); //获取当前小时数(0-23)
				if (0<day && day<6 && 9<=hour && hour<=15){
					this.refresh();
				}else{
					console.log("day 非交易时间不刷新");
				}
			},
			refresh(data_start) {
				let url = '/v3/api/sentiment/market/hot/day?date='
				if(data_start){
					url += data_start
				}else{
					url += Moment().add(-6,'months').format('YYYY-MM-DD'); 
				}
				axios.all([
						request_zzquant({
							'url': url
						}),
						// request_zzquant({
						// 	'url': '/open/sentiment/hot/today'
						// }),
					])
					.then(axios.spread((resp1) => {
						let splitDataItem = this.splitData(resp1['data']['data']);
						let series_data = []
						// console.log(splitDataItem);
						series_data.push({
							name: '按天情绪',
							data: splitDataItem.earn_effect,
							type: 'line',
							symbol: 'circle',
							showSymbol: !this.compact,
							xAxisIndex: 0,
							yAxisIndex: 0,	// 对应上面定义的y轴数据的格式，数组的下标进行对应
							markLine: {
								symbol:'none',//去掉箭头
								data: [{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											width: 1,
											type: "solid",
											symbol: 'circle',
											color: upBorderColor,
										},
										label: {
											position: 'insideEndTop',
											distance: [0, 2],
											fontSize: 10,
											color: upBorderColor,
											formatter: "沸点(90)"
										},
										yAxis: 90
									},
									{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											type: "dotted",
											color: upBorderColor,
										},
										label: {
											position: 'insideEndTop',
											distance: [0, 2],
											fontSize: 10,
											color: upBorderColor,
											formatter: "过热(75)"
										},
										yAxis: 75
									},
									{
											// silent: false,
											lineStyle: { //警戒线的样式  ，虚实  颜色
												type: "dashed",
												symbol: 'circle',
												color: downBorderColor,
											},
											label: {
												position: 'insideEndTop',
												distance: [0, 2],
												fontSize: 10,
												color: downBorderColor,
												formatter: "微冷(45)"
											},
											yAxis: 45
										}, {
											// silent: false,
											lineStyle: { //警戒线的样式  ，虚实  颜色
												type: "dotted",
												symbol: 'circle',
												color: downBorderColor,
											},
											label: {
												position: 'insideEndTop',
												distance: [0, 2],
												fontSize: 10,
												color: downBorderColor,
												formatter: "过冷(35)"
											},
											yAxis: 35
										},
										{
											// silent: false,
											lineStyle: { //警戒线的样式  ，虚实  颜色
												width: 1,
												type: "solid",
												color: downBorderColor,
											},
											label: {
												position: 'insideEndTop',
												distance: [0, 2],
												fontSize: 10,
												color: downBorderColor,
												formatter: "极弱冰点(25)"
											},
											yAxis: 25
										}
								]
							},
							lineStyle: {
								normal: {
									width: 2,
									opacity: 0.9,
									// color: upColor
								}
							},
							
						});

						series_data.push({
							xAxisIndex: 0,
							yAxisIndex: 0,	//数组里面的下标对应
							name: '亏钱效应',
							data: splitDataItem.lose_effect,
							type: 'line',
							symbol: 'circle',
							showSymbol: !this.compact,
							lineStyle: {
								normal: {
									width: 2,
									opacity: 0.9,
									color: downColor
								}
							},
							markLine: {
								symbol:'none',//去掉箭头
								data:splitDataItem.mark_line_day1
							}
						});

						series_data.push({
							xAxisIndex: 1,
							yAxisIndex: 2,
							name: '涨停数',
							data: splitDataItem.zt_num,
							type: 'bar',
							stack: 'total',
							itemStyle: {
								normal: {
									width: 1,
									opacity: 0.7,
									color: upColor
								}
							},
							label: {
								show: !this.compact,
								position: 'top',
							},
							symbol: 'circle',
							markLine: {
								symbol:'none',//去掉箭头
								data:splitDataItem.mark_line_mon
							}
						});

						series_data.push({
							xAxisIndex: 1,
							yAxisIndex: 2,
							name: '跌停数',
							data: splitDataItem.dt_num.map(val => -val),
							type: 'bar',
							stack: 'total',
							itemStyle: {
								normal: {
									width: 1,
									opacity: 0.7,
									color: downColor
								}
							},
							label: {
								show: !this.compact,
								position: 'bottom',
								formatter: function(params) {
									return params.value ? Math.abs(params.value) : '';
								}
							},
							symbol: 'circle'
						});
						
						series_data.push({
							xAxisIndex: 1,
							yAxisIndex: 3,
							name: '连板高度',
							data: splitDataItem.lb_high,
							type: 'line',
							itemStyle: {
								normal: {
									width: 1,
									opacity: 0.7,
									color: upColor
								}
							},
							label: {
								show: !this.compact,
								position: 'top',
							},
							symbol: 'circle'
						});
						


						if (this.line.xAxis && this.line.xAxis.length >= 2) {
							this.line.xAxis[0].data = splitDataItem.categoryData;
							this.line.xAxis[1].data = splitDataItem.categoryData;
						} else {
							this.line['xAxis'] = [
								{ data: splitDataItem.categoryData },
								{ data: splitDataItem.categoryData }
							];
						}
						
						this.line['series'] = series_data;
						this.line.legend.data = ['按天情绪'];
					}))
					.catch(err => {
						console.log(err);
					})
			},
			onDataZoom(event,option){
				if(event.type == 'datazoom'){
					let last_end = event.end
					if(event.start == 0){
						let data_start = Moment(option.xAxis[0].data[0])
						if(data_start <= Moment('2019-09-02')){
							return
						}
						let data_start_new = data_start.add(-6,'months').format("YYYY-MM-DD")
						// console.log(data_start_new)
						this.line.dataZoom[0].start=10
						this.line.dataZoom[0].end=last_end
						this.refresh(data_start_new)
					}
					
				}
				// console.log(option)
			},
			splitData(rawData) {
				let [categoryData, earn_effect, lose_effect, lb_high, zt_num, dt_num] = [
					[],
					[],
					[],
					[],
					[],
					[]
				];
				let [mark_line_mon, mark_line_day1] = [[],[]];
				let pre_month = -1;
				//解构赋值
				// let item2 = rowData2['info'][0];
				// if (rawData[0]['date'] < item2['Day']) {
				// 	categoryData.push(item2['Day']);
				// 	earn_effect.push(item2['strong']);
				// 	lose_effect.push(item2['df_num']);
				// 	lb_high.push(item2['lbgd']);
				// 	zt_num.push(item2['ztjs']);
				// }
				rawData.forEach(item => {
					let item_date = item['date']
					categoryData.push(item_date);
					earn_effect.push(item['earn_effect']);
					lose_effect.push(item['lose_effect']);
					lb_high.push(item['lb_high']);
					zt_num.push(item['zt_num']);
					dt_num.push(item['dt_num'] || 0);
					
					// 计算周一
					if(Moment(item_date).day()==1){
						mark_line_mon.push({
							xAxis:item_date,
							label: {formatter: item_date.substr(8)},
							})
					}
					if(Moment(item_date).month()!=pre_month){
						mark_line_day1.push({
							name:"月初", 
							lineStyle: {
								type: 'dashed',
								color: 'rgba(160, 160, 160, 0.4)',
								width: 1
							},
							label: {
								formatter: item_date.substr(5),
								position: 'insideEndBottom',
								fontSize: 9,
								color: '#888888',
								distance: [0, 4]
							},
							xAxis:item_date})
						pre_month = Moment(item_date).month()
					}
				})
				return {
					categoryData: categoryData,
					earn_effect: earn_effect,
					lose_effect: lose_effect,
					lb_high: lb_high,
					zt_num: zt_num,
					dt_num: dt_num,
					mark_line_mon: mark_line_mon,
					mark_line_day1: mark_line_day1,
				};
			},
			// 最后在beforeDestroy()生命周期内清除定时器：
			beforeDestroy() {
				clearInterval(this.timer);        
				this.timer = null;
			}
		}
	}
</script>

<style scoped>
.chart_hot_day {
	width: 100% !important;
	height: 400px !important;
}
.compact-mode .chart_hot_day {
	height: 290px !important;
}
</style>
